import { makeAutoObservable, runInAction } from "mobx";
import i18n from "i18next";
import MainStore from "MainStore";
import { getdepartment, createdepartment, updatedepartment } from "api/department";
import storeList from "features/Department/DepartmentListView/store";

class NewStore {
  id = 0;
  organization_id = 0;
  name = "";
  description = "";
  is_active = true;
  errors: { [key: string]: string } = {};

  constructor() {
    makeAutoObservable(this);
  }

  clearStore() {
    runInAction(() => {
      this.id = 0;
      this.organization_id = 0;
      this.name = "";
      this.description = "";
      this.is_active = true;
      this.errors = {};
    });
  }

  handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value, type, checked } = event.target;
    (this as any)[name] = type === 'checkbox' ? checked : value;
    if (this.errors[name]) this.errors[name] = "";
  }

  async onSaveClick(onSaved: (id: number) => void) {
    const data = {
      id: this.id,
      organization_id: storeList.idMain,
      name: this.name.trim(),
      description: this.description.trim(),
      is_active: this.is_active,
    };

    this.errors = {};
    if (!data.name) {
      this.errors.name = i18n.t("message:error.required");
      MainStore.openErrorDialog(i18n.t("message:error.alertMessageAlert"));
      return;
    }

    try {
      MainStore.changeLoader(true);
      let response;
      if (this.id === 0) {
        response = await createdepartment(data);
      } else {
        response = await updatedepartment(data);
      }
      if (response.status === 201 || response.status === 200) {
        onSaved(response.data?.id || 0);
        MainStore.setSnackbar(
          this.id === 0
            ? i18n.t("message:snackbar.successSave")
            : i18n.t("message:snackbar.successEdit"),
          "success"
        );
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  }

  async doLoad(id: number) {
    this.id = id;
    if (id === 0) return;
    try {
      MainStore.changeLoader(true);
      const response = await getdepartment(id);
      if ((response.status === 201 || response.status === 200) && response?.data) {
        runInAction(() => {
          const d = response.data;
          this.id = d.id;
          this.organization_id = d.organization_id;
          this.name = d.name || "";
          this.description = d.description || "";
          this.is_active = d.is_active;
        });
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  }
}

export default new NewStore();
